<script setup>
import { onMounted, ref, watch } from 'vue'

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  size: {
    type: String,
    default: '1em',
  },
})

const icon = ref(null)
const attrs = ref({})

watch(
  () => props.name,
  () => loadIcon(),
)

onMounted(() => {
  loadIcon()
})

const loadIcon = async () => {
  const hasExtension = props.name.includes('.')

  if (hasExtension) {
    icon.value = 'img'
    attrs.value = {
      src: props.name,
    }
  } else {
    const loadedModule = await import(`./components/Icon${props.name}.vue`)
    icon.value = loadedModule.default
  }
}
</script>

<template>
  <component
    :is="icon"
    v-if="icon"
    v-bind="attrs"
    class="app-icon"
    :style="{
      width: props.size,
      height: props.size,
    }"
  />
</template>

<style lang="scss" scoped>
.app-icon {
  display: inline-block;
  flex-shrink: 0;
  line-height: 0;
}
</style>
